export default __webpack_public_path__ + "static/media/model-2911332_1920.1ab4e716.jpg";